export interface NewsArticle {
  slug: string;
  title: string;
  cat: string;
  catName: string;
  date: string;
  time: string;
  source: string;
  views: number;
  comments: number;
  heat: number;
  tags: string[];
  excerpt: string;
  cover: string;
  body: string[];
  featured?: boolean;
}

export const articles: NewsArticle[] = [
  {
    slug: "shehui-reverse-travel",
    title: "「反向旅游」走红：这届年轻人为什么不再爱打卡热门景区",
    cat: "shehui",
    catName: "社会热点",
    date: "09-06",
    time: "14:20",
    source: "瓜田观察",
    views: 128000,
    comments: 863,
    heat: 96,
    tags: ["反向旅游", "热门景点", "生活方式"],
    excerpt:
      "当人山人海被写进「避雷帖」，越来越多年轻人把假期投向了人少、小众的小城与县城。热闹不再等于值，安静反而成了新的加分项。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20peaceful%20quiet%20small%20old%20town%20alley%20with%20a%20few%20relaxed%20walkers%20and%20cafes%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20color%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-reverse-travel&orientation=landscape",
    featured: true,
    body: [
      "刚过去的这个小长假，一张「热门景区人从众」的照片又冲上了热搜。评论区的高赞回复却出奇一致：还好我去了隔壁的小县城。曾经被视为「小众攻略」的冷门目的地，正在以肉眼可见的速度走红。",
      "「反向旅游」并不是单纯的反其道而行，而是一种被重新定义的出行逻辑。当交通、住宿、排队成本不断堆高，年轻人开始计算的是单位时间里「真正能体验到的风景」有多少。与其在人墙里自拍，不如在老街巷里慢悠悠地喝一杯当地的手冲。",
      "社交平台上，越来越多博主开始把镜头对准四五线小城、乡镇与县域：物价亲民、人情味浓、节奏缓慢。它们没有惊天动地的名山大川，却胜在松弛和真实。对一个疲惫的都市人来说，这种「低预期的高满足」往往更珍贵。",
      "热闹与安静从来不是单选题。反向旅游的火爆，与其说是对热门景点的背叛，不如说是年轻一代对「旅行究竟买到了什么」有了更清醒的答案——他们愿意为体验买单，却不愿意为人挤人买单。",
    ],
  },
  {
    slug: "yule-festival-red-carpet",
    title: "红毯美学卷土重来：电影节造型背后，是审美还是流量生意",
    cat: "yule",
    catName: "娱乐八卦",
    date: "09-05",
    time: "20:08",
    source: "娱记内参",
    views: 96500,
    comments: 512,
    heat: 90,
    tags: ["电影节", "红毯", "时尚", "造型"],
    excerpt:
      "从高定礼服到国风妆造，一场红毯能养活一整周的营销号。可当所有目光都聚焦在「美不美」上，我们是否也该聊聊造型背后的门道？",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20glamorous%20red%20carpet%20scene%20with%20elegant%20evening%20gown%20silhouettes%20and%20flashing%20camera%20lights%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-festival-01&orientation=landscape",
    featured: true,
    body: [
      "又到一年电影节，红毯环节总是最先「开席」。造型图一出，热搜立刻分好阵营——谁艳压、谁翻车、谁的礼服来自谁家，讨论度甚至高过入围影片本身。",
      "红毯经济早已是一门精密生意：品牌借明星曝光，明星借大牌抬高身价，造型团队则在背后完成一场「审美与流量」的平衡术。设计师要懂的不只是版型与面料，更是话题节奏与社交媒体的传播规律。",
      "今年值得注意的新变化是，越来越多明星开始在本土设计师与传统文化里找灵感。盘扣、织锦、刺绣被重新解构成现代礼服，把「中式美学」推到了聚光灯中央。审美自信的回归，或许比某件礼服本身更有意义。",
      "说到底，红毯是一场大型的视觉公共课。它既关乎美，也关乎身份认同与行业生态。对围观群众而言，能一边吃瓜一边读懂造型背后的一点门道，这瓜才算真正吃明白了。",
    ],
  },
  {
    slug: "wangluo-anonymous",
    title: "「momo大军」在扩编：为什么越来越多人选择隐身冲浪",
    cat: "wangluo",
    catName: "网络热梗",
    date: "09-05",
    time: "11:32",
    source: "冲浪研究所",
    views: 112400,
    comments: 1407,
    heat: 94,
    tags: ["momo", "匿名上网", "网络热梗", "冲浪"],
    excerpt:
      "千篇一律的头像、相同的ID前缀，momo正在成为互联网上最庞大的「神秘组织」。隐身冲浪背后，其实是年轻人在公共舆论场里的一种自我保护。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20many%20identical%20round%20plain%20anonymous%20avatar%20circles%20hiding%20among%20glowing%20chat%20and%20comment%20bubbles%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-momo-01&orientation=landscape",
    body: [
      "在某社交平台，你会发现大量「撞头像」的账号：圆脸小动物、统一格式的ID、看不出性别年龄的简介。他们被称为momo，而「momo大军」正在悄悄扩编。",
      "这套看似「放弃个性」的操作，其实是聪明的。当个人信息、观点倾向甚至消费痕迹都能被轻易顺藤摸瓜，一个「随大流」的身份就是最好的保护色——发言变得安全，吃瓜也不再有心理负担。",
      "更重要的是，momo让讨论重新回归观点本身。卸下现实身份的重担，人们更敢说真话，也更愿意分享真实经历。评论区里动辄上万条的情绪共鸣，往往就藏在这些「匿名脸」之下。",
      "当然，匿名是把双刃剑。它保护表达自由，也偶尔沦为恶意藏身的角落。如何在隐身与负责之间找到平衡，是每个冲浪人都要面对的课题。但至少眼下，越来越多的人选择先给自己留一片安全的瓜田。",
    ],
  },
  {
    slug: "zongyi-observation",
    title: "观察类综艺霸屏：年轻人的「电子榨菜」为何越看越上头",
    cat: "zongyi",
    catName: "综艺现场",
    date: "09-04",
    time: "21:15",
    source: "综艺速递",
    views: 78300,
    comments: 431,
    heat: 82,
    tags: ["观察类综艺", "电子榨菜", "慢综艺"],
    excerpt:
      "从恋爱到职场再到独居生活，观察类综艺几乎占领了下饭场景。弹幕里的共鸣，本质上是我们隔着屏幕在偷偷照镜子。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20cozy%20warm%20living%20room%20with%20a%20big%20tv%20screen%20showing%20lifestyle%20variety%20show%2C%20couch%20and%20snacks%20and%20tea%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-observation-01&orientation=landscape",
    body: [
      "如果给当代年轻人的吃饭标配排个名，观察类综艺大概能挤进前三。屏幕上嘉宾的一日三餐、情感博弈、职场挣扎，都成了碗边最下饭的「电子榨菜」。",
      "观察类综艺走红的密码，在于它精准地击中了「被看见」的需求。节目里的每一个话题，几乎都能无缝接入观众自己的真实生活：合租的边界感、加班的委屈、相亲的尴尬……弹幕里刷过的每一句「世另我」，都是一次隔空击掌。",
      "比起高高在上的说教，这类节目更像一场坦诚的围炉夜谈。棚内观察嘉宾的犀利点评，又给原本琐碎的日常加了一层思考的滤镜，让观众在娱乐之外，还能顺走一点关于生活与人际的启发。",
      "当「卷」成为日常，人们反而更渴望看到松弛、真实与被理解的样子。观察类综艺的火，本质上烧的是我们每个人心底那份「想被好好看懂」的小愿望。",
    ],
  },
  {
    slug: "wangluo-bullet-screen",
    title: "弹幕文化十年：一起看片的人变多了，孤独反而变少了",
    cat: "wangluo",
    catName: "网络热梗",
    date: "09-04",
    time: "16:44",
    source: "冲浪研究所",
    views: 68900,
    comments: 377,
    heat: 78,
    tags: ["弹幕", "追剧", "亚文化", "互联网"],
    excerpt:
      "从一个冷门技术到全网标配，弹幕用十年时间重塑了我们看片的方式。无数飘过的文字背后，藏着这个时代关于陪伴的答案。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20movie%20screen%20with%20many%20vertical%20glowing%20text%20bullet%20comment%20lines%20flying%20over%20audience%20silhouettes%20watching%20together%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-danmaku-01&orientation=landscape",
    body: [
      "十年前，弹幕还只是某个小众弹幕站点的「专利」；如今它已成为几乎所有长视频平台的标配。那些从屏幕右侧呼啸而过的文字，串起了一代人的观看记忆。",
      "很多人最初觉得弹幕「碍眼」，直到某个笑点瞬间被集体刷屏，才发现：原来还有无数人正和我一起，在同一帧画面里爆笑。这种「实时共鸣」制造了一种奇妙的分身陪伴——哪怕一个人深更半夜窝在沙发里，也仿佛身处万人影院。",
      "从「前方高能」到「名场面打卡」，弹幕还发展出一套自己的语言体系。新人入坑时需要学习「黑话」，老用户则靠暗号辨认同类。它不再只是观看的附属，而是内容本身的一部分，甚至能反过来给视频「加戏」。",
      "技术让千万人同看一部剧成为可能，弹幕则让千万人真正「坐在了同一个房间里」。当现实中的社交越来越疲惫，屏幕里的这些陪伴与热闹，反而成了很多人心中那点难得的暖意。",
    ],
  },
  {
    slug: "yule-drama-revenue",
    title: "热播剧收官战：观众追的到底是剧情，还是「养成感」",
    cat: "yule",
    catName: "娱乐八卦",
    date: "09-03",
    time: "22:01",
    source: "娱记内参",
    views: 85700,
    comments: 601,
    heat: 86,
    tags: ["热播剧", "追剧", "剧集", "平台"],
    excerpt:
      "从热搜冲榜到二创刷屏，一部热播剧的收官总是兵荒马乱。剧迷们一边喊着「舍不得」，一边用脚投票决定下一部该追什么。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20glowing%20smartphone%20screen%20showing%20a%20tv%20series%20playback%20surrounded%20by%20popcorn%20and%20ticket%20and%20confetti%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-drama-01&orientation=landscape",
    body: [
      "每个热播季的末尾都像一场集体毕业礼。主创发收官长文、剧迷疯狂二创、平台放出番外花絮……所有人都试图把「剧集已完结」这个事实，拖得再慢一点。",
      "如今的追剧早已不是「打开电视看两集」那么简单。从开播前的期待值管理，到播出期间的实时讨论，再到收官后的物料考古，观众与一部剧之间建立起的，是一种漫长的「养成式」情感连接。",
      "也因此，光有好看的情节已经不够。观众更在意角色是否立得住、人物关系是否值得反复回味、世界观能否承载更多想象。剧集好不好，最后往往不只是数据说了算，而是「有没有人愿意为它写长评、做剪辑、产粮」。",
      "收官不是终点，而是一场漫长讨论的开始。真正的热播剧，是在大结局之后，仍然能被反复提起、逐帧品鉴的那种。下一部剧，会是谁接住这波热情呢？我们拭目以待。",
    ],
  },
  {
    slug: "shehui-citywalk",
    title: "citywalk爆火之后：我们该如何重新「走」进一座城市",
    cat: "shehui",
    catName: "社会热点",
    date: "09-03",
    time: "10:26",
    source: "瓜田观察",
    views: 64200,
    comments: 355,
    heat: 72,
    tags: ["citywalk", "城市漫步", "CityWalk", "出行"],
    excerpt:
      "从「特种兵式旅游」到漫无目的的citywalk，年轻人的出行观来了个一百八十度转弯。走街串巷之下，藏着的是与城市重新建立连接的心愿。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20leisure%20city%20walk%20route%20line%20weaving%20through%20old%20buildings%20cafes%20and%20street%20trees%20with%20a%20couple%20walking%20slowly%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-citywalk-01&orientation=landscape",
    body: [
      "如果把前两年的旅游热比作一场争分夺秒的「特种兵拉练」，那当下的citywalk就像一场漫无目的的「城市遛弯」。没有固定路线，也不设打卡清单，走哪算哪，反而成了新的时尚。",
      "citywalk流行的背后，是城市生活方式的一次回归。我们常常生活在一座城市里，却很少真正「走过」它。高楼写字楼之间的缝隙里，藏着老茶馆、手作店和开着花的墙头——只有放慢脚步，才能发现这些日常中被忽略的温柔细节。",
      "它同时也是一种低成本的情绪疗愈。不用远行、不必规划，换上舒适的鞋，出门就是一场说走就走的旅行。对正在被快节奏裹挟的都市人来说，能随时开启的citywalk，是一剂不需要预约的解药。",
      "一座城市的美，从来不只在那些地标性建筑上，更在街角转弯处的人间烟火里。当我们愿意重新用脚步丈量城市，才算真正开始读懂它。下一次周末，不妨也把手机放进口袋，出门走一走。",
    ],
  },
  {
    slug: "yule-celebrity-travel",
    title: "明星旅居成新趋势：从「度假式通告」到「慢生活IP」",
    cat: "yule",
    catName: "娱乐八卦",
    date: "09-02",
    time: "19:40",
    source: "娱记内参",
    views: 52100,
    comments: 278,
    heat: 66,
    tags: ["明星", "旅居", "慢生活", "人设"],
    excerpt:
      "越来越多的明星不再满足于「闪现式」的度假大片，而是搬进山里、海边与古镇，开启以月为单位的旅居生活。人设之外，这届艺人到底在找什么？",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20cozy%20wooden%20cabin%20by%20a%20calm%20lake%20with%20a%20vintage%20suitcase%20and%20morning%20tea%20and%20misty%20mountains%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-celebrity-travel-01&orientation=landscape",
    body: [
      "如果你最近刷社交媒体，一定见过不少「在乡下住了一个月」的明星日常。他们放下浓妆与通告，分享种菜、钓鱼、晒背的片段，评论区一片「这才是生活」的羡慕。",
      "明星旅居的走红，是一种双向奔赴。对艺人来说，远离镁光灯的慢生活既是情绪充电，也是口碑重塑的良机——接地气、松弛感，比任何精心设计的人设都更有说服力。对品牌与合作方而言，这类内容又是一块自带流量的「生活美学」试金石。",
      "当然，镜头里的田园牧歌，往往只是真实生活的一个切面。挑水劈柴的另一面是蚊虫与繁琐。但对长期处于高压节奏中的公众人物来说，哪怕只是短暂地「逃离」，也是难得的自我修复。",
      "当我们一边吃着明星旅居的瓜，一边在评论区写下「好想辞职去山里」，或许真正被打动的，是我们自己对松弛生活的渴望。生活方式的探讨，永远是围观群众最爱也最共情的话题之一。",
    ],
  },
  {
    slug: "shehui-concert-economy",
    title: "演唱会经济点燃一座城：跨城观演为什么成了新风尚",
    cat: "shehui",
    catName: "社会热点",
    date: "09-01",
    time: "15:12",
    source: "瓜田观察",
    views: 118600,
    comments: 789,
    heat: 92,
    tags: ["演唱会", "跨城观演", "演出经济", "文旅"],
    excerpt:
      "「为一场演出奔赴一座城」正在成为越来越多人报复性享受生活的方式。演出经济拉动的不只是票房，更是一整座城的酒店、餐饮与交通。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20bright%20concert%20stage%20with%20colorful%20light%20beams%20and%20cheering%20audience%20silhouettes%20at%20night%20inside%20a%20city%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-concert-01&orientation=landscape",
    body: [
      "今年以来，演唱会市场持续高热。抢票拼手速只是第一步，不少歌迷甚至提前请好假、订好机票酒店，只为奔赴几千公里外的那一场演出。",
      "「演出+旅行」的组合，正在重塑城市的文旅版图。一场万人演唱会的落地，能带动周边酒店满房、餐饮翻台、商圈人流激增，还被许多城市写进了本地文旅的「留客攻略」。票根，成了新时代的「城市通行证」。",
      "对观众而言，跨城观演的意义早已超过听歌本身。它是一次盛大的集体情绪释放，是和许久未见的朋友奔赴同一片欢呼的仪式感，也是给自己辛苦生活的一次犒赏。跟着偶像走，其实是跟着热爱走。",
      "当演出经济持续升温，越来越多城市开始争抢这张「演出名片」。可以预见的是，未来会有更多小众城市因为一场演出而被看见。而对热爱现场的人来说，花一张票的钱，换一次说走就走的热烈奔赴，这笔账怎么算都值。",
    ],
  },
  {
    slug: "zongyi-slow-show",
    title: "慢综艺回春：为什么大家都想「逃」进山里",
    cat: "zongyi",
    catName: "综艺现场",
    date: "08-31",
    time: "12:50",
    source: "综艺速递",
    views: 45600,
    comments: 219,
    heat: 60,
    tags: ["慢综艺", "治愈", "旅行综艺"],
    excerpt:
      "快节奏时代，慢综艺反而成了「刚需」。从山野民宿到田间厨房，明星们围炉煮茶的日子，成了观众心头的一处精神避难所。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20misty%20mountain%20cabin%20with%20a%20warm%20campfire%20and%20picnic%20table%20and%20tea%20pot%20in%20a%20bamboo%20forest%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=800&seq=cover-slow-show-01&orientation=landscape",
    body: [
      "当生活被各种进度条和DDL填满，慢综艺却像一股清流，重新回到观众的片单里。没有激烈赛制、没有淘汰压力，有的只是几个人在山里慢悠悠地生活。",
      "这类节目的治愈力，来自一种罕见的「允许无事发生」。嘉宾们砍柴、做饭、发呆、闲聊，镜头不急着推进，观众也渐渐被这种节奏安抚。有人戏称，看慢综艺就像是给紧绷的神经做了一次SPA。",
      "山野、民宿、老友重逢，构成了慢综艺的固定配方。当嘉宾围坐炉边说出那些关于成长与释怀的真心话时，弹幕里飘过的「被治愈了」，往往是观众在嘉宾身上看见了自己的影子。",
      "从快节奏的竞技综艺，到如今慢综艺的回春，折射出的其实是大众情绪的变化——大家在加速奔跑之后，终于愿意停下来，认真地过好一顿饭、一场日落。生活不必时刻都在赶路，偶尔「逃」进山里，也是一种勇敢的充电。",
    ],
  },
];

export function getArticle(slug: string): NewsArticle | undefined {
  return articles.find((a) => a.slug === slug);
}

export function formatCount(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  return String(n);
}